import React, { Component} from 'react'
import ReactDOM from 'react-dom';
import { PropTypes, object } from 'prop-types'
import {
    getSelectOptions,
    updateComponent,
    fetchData
} from '../../state/actions/componentsActions'
import { connect } from 'react-redux'
import Select from 'react-select'
//import 'react-select/dist/react-select.css';
import './styles.css'
import { camelize } from '../../utils'
import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'



export class MultiSelect extends Component {
    
    constructor(props) {
        super(props)
    }
    componentWillMount() {
        if (
            this.props.component.hasOwnProperty('options') &&
            (this.props.component.values || []).length === 0 &&
            !this.props.component.fetchInProgress
        ) {
            const { dispatch } = this.props
            this.props.component.fetchInProgress = true
            dispatch(getSelectOptions(this.props.component))
        }
    }

    componentDidMount() {
        const { dispatch /* , step */ } = this.props
        dispatch(fetchData(this.props.component.id, null, true))
    }
    componentWillReceiveProps(nextProps) {
        const { dispatch } = this.props
        if (
            (nextProps.component &&
                this.props.component.values.length === 0 &&
                nextProps.component.values.length >= 0) ||
            (nextProps.component &&
                this.props.component.values.length > 0 &&
                nextProps.component.values.length === 0)
        ) {
            if (!this.props.component.value && !!this.props.component.initialValue) {
                this.props.component.value = this.props.component.initialValue
            }

            if (
                this.props.component.hasOwnProperty('options') &&
                (this.props.component.values || []).length === 0 &&
                !this.props.component.fetchInProgress
            ) {
                this.props.component.fetchInProgress = true
                dispatch(getSelectOptions(this.props.component))
            }
        }
    }
    onValueChange(selectedOption) {
        const { dispatch, component } = this.props
        //this.props.setSelectedOptions.push(selectedOption)
        dispatch(updateComponent(component.id, { value: selectedOption }))
    }
    renderOptions() {
        
        const { widget, component } = this.props
        let values = component.values
        let componentValues=[]
    let isObjectArray = false
    if (
      values &&
      values.constructor.toString().indexOf('Array') > -1 &&
      typeof values[0] === 'object'
    ) {
      values = values.filter(v => !!v.value && v.value !== '-1')
      isObjectArray = true
      values = uniqBy(values, 'value')
    } else {
      values = Array.from(new Set(values))
    }
    values.map(v => {
        if (!isObjectArray) {
            var item={}
        item.value=v,
        item.label=v
        componentValues.push(item);
        }
    });
        return (
            // <div {...css(this.props.styles.component,  component.fullWidth && this.props.styles.singleField)}>
            <Select {...css(this.props.styles.try,this.props.styles['input--select'],
            component.status.indexOf('error') > -1 &&
              this.props.styles['input--invalid'])}
            name={component.id}
            value={this.props.setSelectedOptions}
            onChange={event => {
                this.onValueChange(event)
            }}
            options={componentValues} placeholder={component.cleanName}
            multi={true}
            removeSelected={false}
            joinValues={true}
            simpleValue={true}
            delimiter="||"
            />
           
            //</div>
        )
    }
    validateRequired() {
        const { component } = this.props
        if (
          component.validations &&
          component.validations.isRequired &&
          !component.isDisabled
        ) {
          return true
        }
        return false
      }

    render() {
        const { component } = this.props
        return (
            <div {...css(this.props.styles.divmain,this.props.styles.component,  component.fullWidth && this.props.styles.singleField)}>
                  <span
          {...css(
            this.props.styles.label,
            component.value !== '' && this.props.styles.labelActive,
          )}
        >
          {component.cleanName}
        </span>
                {this.renderOptions()}
    <p>{!!component.staticDescription && component.staticDescription}</p>
              
                <small {...css(this.props.styles['error-msg'])}>
          {camelize(component.errorMessage[0], true, true)}
               </small>
            </div>
        )
    }

}

MultiSelect.propTypes = {
    widget: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    styles: PropTypes.object.isRequired,
    setSelectedOptions:object.array
}

const mapStateToProps = (state /*, ownProps*/) => {
    const { step } = state
    /*return { component: components[ownProps.component.id] }*/
    return { step }
}
export default connect(mapStateToProps)(withStyles(Styles)(MultiSelect))



// WEBPACK FOOTER //
// ./components/multiselect/index.js